
export type SuggestedTimeDTO = {
    statusColorCode: number
    optimizationChoices: string
    optimizationMessage: string
}
export const suggestedTimeDefault: SuggestedTimeDTO =
{
    statusColorCode: 0,
    optimizationChoices: '',
    optimizationMessage: ''
}

//Pinterest DTO's
export type BoardMediaDto = {
    imageCoverUrl: string;
    pinThumbnailUrls: string[];
};

export type BoardOwnerDto = {
    username: string;
};

export type BoardDto = {
    id: string;
    createdAt: string;
    boardPinsModifiedAt: string;
    name: string;
    description: string;
    collaboratorCount: number;
    pinCount: number;
    followerCount: number;
    media: BoardMediaDto;
    owner: BoardOwnerDto;
    privacy: string;
};

export type GetAllBoardsResponseDto = {
    items: BoardDto[];
    bookmark: string;
};
